import React from 'react'
import { OfferPageState } from './offerPageStateReducer'

// @ts-ignore
const OfferPageStateContext = React.createContext<OfferPageState>(undefined)

export default OfferPageStateContext
